export default {
  title: 'AI Assistant',
  welcomeTitle: 'Hello',
  welcomeDesc:
    'I am an AI assistant. I can help you create inspection tasks, plan routes, and analyze risks. Type your request below.',
  realtimeAlarm: 'Live Alerts',
  alarmDetected: 'Detected {label}',
  routeName: 'Route:',
  deviceName: 'Device:',
  chatEmpty: 'Type your question below',
  inputPlaceholder: 'Enter your question',
  voiceInput: 'Voice input',
  voiceInputActive: 'Listening',
  stopVoiceInput: 'Stop voice input',
  send: 'Send',
  voiceNoTranscript: 'No speech detected. Please try again.',
  streamErrorDefault: 'Streaming response error.',
  requestFailed: 'Request failed.',
  taskComplete: 'Current task completed',
  confirmExecuteTask: 'Confirm task execution',
  cancelExecuteTask: 'Cancel task execution',
  alarmLabel: {
    smoke: 'Smoke',
    fire: 'Fire',
    box: 'Clutter',
    electric_meter_ocr: 'Meter reading',
    umbrella: 'Street vendor',
    vehicle_violation: 'Illegal parking',
  },
  report: {
    inspectionInfo: 'Inspection Info:',
    inspectionArea: 'Area: {area}',
    taskName: 'Task: {name}',
    inspectionTime: 'Time: {time}',
    inspectionTarget: 'Target: {target}',
    defaultArea: 'Bay Area Smart Park',
    abnormalSummary: 'Incident Summary:',
    serialNo: 'No.',
    type: 'Type',
    alarmCount: 'Count',
    noAlarmData: 'No alarm data',
    summaryAdvice: 'Summary & Recommendations:',
    summaryLine:
      'Summary: {count} incident(s) detected; primary type: {type}.',
    adviceWithAlarms:
      'Recommendation: Prioritize high-frequency illegal parking spots, arrange on-site removal and follow-up; increase patrols during peak hours and continue monitoring key areas.',
    adviceNoAlarms:
      'Recommendation: No illegal parking alerts found; maintain the current inspection strategy with routine patrols during morning and evening peaks.',
    unknownType: 'Unknown type',
    noSignificantAbnormal: 'No significant incidents',
  },
}
